/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Component, Fragment } from 'react'

type Props = {
  regionId?: string | null
  regionName: string | null
  fetchProvidersIfNeeded: () => void
}

class DeploymentRegion extends Component<Props> {
  componentDidMount() {
    const { fetchProvidersIfNeeded } = this.props
    fetchProvidersIfNeeded()
  }

  render() {
    const { regionId, regionName } = this.props

    if (!regionId) {
      return null
    }

    if (regionId === `ece-region`) {
      return null
    }

    return <Fragment>{regionName}</Fragment>
  }
}

export default DeploymentRegion
